"use client";

import { useEffect, useRef } from "react";

import { gsap, ScrollTrigger } from "@/lib/gsap";

import styles from "./ReasonWhy.module.scss";

gsap.registerPlugin(ScrollTrigger);

export default function ReasonContent() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sectionRef.current) return;

    const ctx = gsap.context(() => {
      gsap.set(sectionRef.current, {
        opacity: 0,
        y: 80,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: ".reason-wrapper-trigger",
          start: "top top",
          end: "top+=700 top",
          scrub: true,
        },
      });

      // TEXT APPEAR
      tl.to(sectionRef.current, {
        opacity: 1,
        y: 0,
        ease: "none",
        duration: 0.35,
      });

      // HOLD TEXT
      tl.to({}, { duration: 0.3 });

      // TEXT DISAPPEAR
      tl.to(sectionRef.current, {
        opacity: 0,
        y: -80,
        ease: "none",
        duration: 0.35,
      });
    });

    return () => {
      ctx.revert();
    };
  }, []);

  return (
    <section className={styles.reasonSection}>
      <div className={styles.reasonGrid} ref={sectionRef}>
        <div>
          <h2 className={styles.reasonTitle}>
            Why Kia Partners with FIFA
          </h2>
        </div>

        <div className={styles.reasonTexts}>
          <p>
            FIFA has created the world’s most powerful
            stage, bringing people together through
            football. Across borders and languages,
            football has become a global culture —
            deeply embedded in everyday life around
            the world.
          </p>

          <p>
            This global influence closely aligns with
            Kia’s values: connecting people and the
            world through movement. Through its
            partnership with FIFA, Kia continues to
            create meaningful moments that inspire
            connection and engagement.
          </p>
        </div>
      </div>
    </section>
  );
}